import React from 'react';
import { Box, MenuItem, Select, FormControl, SelectChangeEvent } from '@mui/material';
import { useLanguage } from '../context/LanguageContext';
import { useTranslation } from 'react-i18next';

const LanguageSelector: React.FC = () => {
  const { currentLanguage, changeLanguage } = useLanguage();
  const { t } = useTranslation();

  const handleChange = (event: SelectChangeEvent) => {
    changeLanguage(event.target.value as string);
  };

  return (
    <Box sx={{ minWidth: 120 }}>
      <FormControl fullWidth size="small">
        <Select
          value={currentLanguage}
          onChange={handleChange}
          displayEmpty
          sx={{ 
            color: 'inherit',
            '& .MuiOutlinedInput-notchedOutline': { 
              borderColor: 'transparent' 
            },
            '&:hover .MuiOutlinedInput-notchedOutline': { 
              borderColor: 'rgba(255, 255, 255, 0.3)' 
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': { 
              borderColor: 'rgba(255, 255, 255, 0.5)' 
            }
          }}
        >
          <MenuItem value="da">Dansk</MenuItem>
          <MenuItem value="en">English</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
};

export default LanguageSelector; 